import { getGenericEndpoint } from './get.api';
import type { GetSimpleFooterResponse } from './types';

export const getSimpleFooter = async (lang?: string) => {
	return await getGenericEndpoint<GetSimpleFooterResponse>(
		'nav/footer',
		lang
	);
};
